import dayjs from "dayjs";
import "./style.css";
import { Col, Row, Card } from "antd";
import { useCallback, useEffect, useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  // setImeiList,
  setVehicleDetails,
} from "../../../reducers/eolSlice";
import { getApis } from "../../Common/apis";
import {
  // imeiListApiUrl,
  vehicleDetailsApiUrl,
  vehiclePartAttributeApiUrl,
  vehicleTravelledDistanceUrl,
} from "components/Common/endpoints";
import { getGrafanaBaseURL, 
  getGrafanaInterval, 
  getGrafanaBatteryDataInterval,
  getGrafanaBatteryStackInterval,
  getGrafanaBatteryCellInterval, 
} from "components/Common/Utils";
import { useRequiredAccess } from "hooks/useRequiredAccess"
import { ORG_TYPES, UNITS } from "components/Common/Constants";
import { VEHICLE_STATUS } from "components/Common/Grafana/Constants";
import GetIframe from "components/Common/Grafana/GetIframe";
import TelemetryPanels from "./Panels/Telemetry";
import MotorPanels from "./Panels/Motor";
import BatteryPanels from "./Panels/Battery";
import VehicleDetails from "../VehicleDetails";
import DaysPickerNew from "components/Common/DaysPickerNew";
import VehicleCurrentStatus from "components/Common/VehicleCurrentStatus";
import BarChartGraph from "./barChart";
import { setPageLoader } from "reducers/loaderSlice";
import TripsTable from "./TripsTable";

const VehicleAnalytics = () => {
  const location = useLocation();
  let startTime = dayjs().startOf('day').valueOf();
  let endTime = dayjs().valueOf();
  const dispatch = useDispatch();
  // const imeiList = useSelector((state) => state.eol.imeiList);
  const [vehicle, setVehicle] = useState(location?.state?.vehId ? location?.state : null);
  // const [imei, setImei] = useState(imeiList[0]);
  const [rearTyreDiameter, setRearTyreDiameter] = useState(null);
  const [selectedDateRange, setSelectedDateRange] = useState([startTime, endTime]);
  const [datePickerType, setDatePickerType] = useState('day');
  const [travelledDistanceData, setTravelledDistanceData] = useState({});
  
  const authToken = localStorage.getItem("authToken");
  const checkAccess = useRequiredAccess(
    [],
    [ORG_TYPES.ADMINISTRATOR, ORG_TYPES.MANUFACTURER]
  );

  // const getImeiList = useCallback(async () => {
  //   await getApis(imeiListApiUrl, {}, authToken)
  //     .then((response) => {
  //       dispatch(setImeiList(response?.data));
  //       if (location?.state?.imei) {
  //         setImei(location.state.imei);
  //       } else {
  //         setImei(response?.data[0]);
  //       }
  //     })
  //     .catch((e) => toast.error(e.response?.data?.message));
  // }, [authToken, dispatch, location]);

  const getVehicleDetails = useCallback(async () => {
    dispatch(setVehicleDetails({}));
    const response = await getApis(
      vehicleDetailsApiUrl,
      {
        imei: vehicle?.vehImei,
      },
      authToken
    );
    dispatch(setVehicleDetails(response?.data));
  }, [authToken, dispatch, vehicle?.vehImei]);

  const getVehiclePartAttribite = useCallback(async () => {
    await getApis(
      vehiclePartAttributeApiUrl,
      {
        imei: vehicle?.vehImei,
        partType: "REAR_TYRE",
      },
      authToken
    )
      .then((response) => {
        setRearTyreDiameter(
          response?.data?.attributes?.rearTyreDiameter || null
        );
      })
      .catch((e) => toast.error(e.response?.data?.message));
  }, [authToken, vehicle?.vehImei]);


  const getVehicleDistanceData = useCallback(async () => {
    // const startDate = dayjs(selectedDateRange[0]);
    await getApis(
      vehicleTravelledDistanceUrl,
      {
        imei: vehicle?.vehImei,
        from: selectedDateRange[0],
        to: selectedDateRange[1],
        timeFilter: datePickerType.toUpperCase(),
      },
      authToken
    )
      .then((res) => {
        if (res.status === 200) {
          setTravelledDistanceData({ ...res.data } || {});
        }
        dispatch(setPageLoader(null));
      })
      .catch((e) => {
        setTravelledDistanceData({});
        dispatch(setPageLoader(null));
        console.log(e);
      });

      // eslint-disable-next-line
  }, [authToken, dispatch, vehicle?.vehImei, selectedDateRange]);

  // useEffect(() => {
  //   // getImeiList();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [getImeiList]);

  useEffect(() => {
    checkAccess();
    if (vehicle?.vehImei && vehicle?.vehImei !== "") {
      getVehicleDetails();
      getVehiclePartAttribite();
      getVehicleDistanceData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    getVehicleDetails,
    getVehiclePartAttribite,
    getVehicleDistanceData,
    vehicle?.vehId,
  ]);

  const onChangeImei = (_,value) => {
    setVehicle(value);
    // dispatch(setVehicleDetails({}));
  };

  const onChangeSelectedDateRange = (dateRange) => {
    setSelectedDateRange(dateRange);
  }

  const onChangeDatePickerType = (dateType) => {
    setDatePickerType(dateType)
  }

  const baseFilterObject = useMemo(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));

    const baseFilter = {
      orgId: userDetails?.currentOrganisation?.grafanaOrganisationId,
      vehicle_id: vehicle?.vehId,
      motorfield: null,
      batteryfield: null,
      rear_wheel_diameter: rearTyreDiameter,
    };

    return dayjs(selectedDateRange[1]) > dayjs().subtract(1, "hour")
      ? {
          ...baseFilter,
          bucket_interval: getGrafanaInterval(selectedDateRange[0], selectedDateRange[1]),
          from: selectedDateRange[0],
          refresh: "1m",
        }
      : {
          ...baseFilter,
          bucket_interval: getGrafanaInterval(selectedDateRange[0], selectedDateRange[1]),
          from: selectedDateRange[0],
          to: selectedDateRange[1],
        };

    // eslint-disable-next-line
  }, [vehicle?.vehImei, selectedDateRange, rearTyreDiameter]);

  const baseBatteryFilterObject = useMemo(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));

    const baseFilter = {
      orgId: userDetails?.currentOrganisation?.grafanaOrganisationId,
      vehicle_id: vehicle?.vehId,
      // imei: vehicle?.vehImei,
      motorfield: null,
      batteryfield: null,
      rear_wheel_diameter: rearTyreDiameter,
    };

    return dayjs(selectedDateRange[1]) > dayjs().subtract(1, "hour")
      ? {
          ...baseFilter,
          bucket_interval: getGrafanaBatteryDataInterval(selectedDateRange[0], selectedDateRange[1]),
          from: selectedDateRange[0],
          refresh: "1m",
        }
      : {
          ...baseFilter,
          bucket_interval: getGrafanaBatteryDataInterval(selectedDateRange[0], selectedDateRange[1]),
          from: selectedDateRange[0],
          to: selectedDateRange[1],
        };

    // eslint-disable-next-line
  }, [vehicle?.vehImei, selectedDateRange, rearTyreDiameter]);

  const baseBatteryStackFilterObject = useMemo(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));

    const baseFilter = {
      orgId: userDetails?.currentOrganisation?.grafanaOrganisationId,
      vehicle_id: vehicle?.vehId,
      // imei: vehicle?.vehImei,
      motorfield: null,
      batteryfield: null,
      rear_wheel_diameter: rearTyreDiameter,
    };

    return dayjs(selectedDateRange[1]) > dayjs().subtract(1, "hour")
      ? {
          ...baseFilter,
          bucket_interval: getGrafanaBatteryStackInterval(selectedDateRange[0], selectedDateRange[1]),
          from: selectedDateRange[0],
          refresh: "1m",
        }
      : {
          ...baseFilter,
          bucket_interval: getGrafanaBatteryStackInterval(selectedDateRange[0], selectedDateRange[1]),
          from: selectedDateRange[0],
          to: selectedDateRange[1],
        };

    // eslint-disable-next-line
  }, [vehicle?.vehId, selectedDateRange, rearTyreDiameter]);

  const baseBatteryCellFilterObject = useMemo(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));

    const baseFilter = {
      orgId: userDetails?.currentOrganisation?.grafanaOrganisationId,
      vehicle_id: vehicle?.vehId,
      // imei: vehicle?.vehImei,
      motorfield: null,
      batteryfield: null,
      rear_wheel_diameter: rearTyreDiameter,
    };

    return dayjs(selectedDateRange[1]) > dayjs().subtract(1, "hour")
      ? {
          ...baseFilter,
          bucket_interval: getGrafanaBatteryCellInterval(selectedDateRange[0], selectedDateRange[1]),
          from: selectedDateRange[0],
          refresh: "1m",
        }
      : {
          ...baseFilter,
          bucket_interval: getGrafanaBatteryCellInterval(selectedDateRange[0], selectedDateRange[1]),
          from: selectedDateRange[0],
          to: selectedDateRange[1],
        };

    // eslint-disable-next-line
  }, [vehicle?.vehId, selectedDateRange, rearTyreDiameter]);


  const getVariableKeys = useMemo(() => {
    return dayjs(selectedDateRange[1]) > dayjs().subtract(1, "hour")
      ? VEHICLE_STATUS.RUNNING_VARIABLES
      : VEHICLE_STATUS.BASE_VARIABLES;
  }, [selectedDateRange]);

  return (
    <div data-testid="vehicle-status" className="vehicle-status-page">
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={24} lg={6} xl={5}>
          <Row gutter={[16, 16]} className="h100">
            <Col span={24}>
              <VehicleDetails
                onChangeImei={onChangeImei}
                imei={vehicle}
                cardHeight={"100%"}
                extraDetails={true}
              />
            </Col>
          </Row>
        </Col>

        <Col xs={24} sm={24} md={24} lg={18} xl={19}>
          <Row gutter={[16,16]} justify={"space-between"}>
            <Col xs={24} sm={24} md={6}>
              <VehicleCurrentStatus vehicle={vehicle} />
            </Col>
            <Col xs={24} sm={24} md={18} className="justify-right">
              <DaysPickerNew 
                selectedDateRange={selectedDateRange}
                onChangeSelectedDateRange={onChangeSelectedDateRange}
                onChangeDatePickerType={onChangeDatePickerType}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="trips-distance-row mt1">
            <Col xs={24} sm={24} md={12} lg={12} xl={9}>
              <Card
                bordered={false}
                title={"Trip History"}
                className="h100 trips-table-card"
              >
                <TripsTable 
                  vehicle={vehicle}
                  startTime={selectedDateRange[0]}
                  endTime={selectedDateRange[1]}
                />
              </Card>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={15}
              className="h100"
              style={{ display: "flex", flexDirection: "column" }}
              data-testid="trips-graph"
            >
              <Card
                bordered={false}
                className="trips-distance-graph-card h100"
                title={"Distance"}
              >
                <div className="plr1">
                  <Row justify={"space-between"} className="w100 mb1 grey-box">
                    <div className="pl1 mr1">
                      Distance Travelled :{" "}
                      <span className="fs1 bold">
                        {travelledDistanceData?.distanceTravelled} {UNITS.KM}
                      </span>
                    </div>
                    <div className="pl1 mr1">
                      Current Odometer :{" "}
                      <span className="fs1 bold">
                        {travelledDistanceData?.odometerReading} {UNITS.KM}
                      </span>
                    </div>
                  </Row>
                </div>
                <BarChartGraph
                  data={travelledDistanceData?.timeDistanceBreakUps || []}
                  startTime={selectedDateRange[0]}
                  endTime={selectedDateRange[1]}
                  datePickerType={datePickerType}
                />
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row gutter={[16, 16]} className="mt1">
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <Row gutter={[16, 16]}>
            <Col span={24} id="location-speed">
              <GetIframe
                title="Location Speed"
                url={getGrafanaBaseURL(
                  VEHICLE_STATUS.DASHBOARD_ID,
                  VEHICLE_STATUS.DASHBOARD_NAME
                )}
                panelId={VEHICLE_STATUS.PANEL_ID["locationSpeed"]}
                variableObject={baseFilterObject}
                variableKeys={getVariableKeys}
                width="100%"
                height="250"
                divId="location-speed"
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mt05">
            <Col span={24} id="location-altitude">
              <GetIframe
                title="Location Altitude"
                url={getGrafanaBaseURL(
                  VEHICLE_STATUS.DASHBOARD_ID,
                  VEHICLE_STATUS.DASHBOARD_NAME
                )}
                panelId={VEHICLE_STATUS.PANEL_ID["locationAltitude"]}
                variableObject={baseFilterObject}
                variableKeys={getVariableKeys}
                width="100%"
                height="250"
                divId="location-altitude"
              />
            </Col>
          </Row>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} id="vehicle-route">
          <GetIframe
            title="Vehicle Route"
            url={getGrafanaBaseURL(
              VEHICLE_STATUS.DASHBOARD_ID,
              VEHICLE_STATUS.DASHBOARD_NAME
            )}
            panelId={VEHICLE_STATUS.PANEL_ID["route"]}
            variableObject={baseFilterObject}
            variableKeys={getVariableKeys}
            width="100%"
            height="514"
            divId="vehicle-route"
          />
        </Col>
      </Row>

      <Row gutter={[16, 16]} className="mt075">
        <Col span={24}>
          <TelemetryPanels
            baseUrl={getGrafanaBaseURL(
              VEHICLE_STATUS.DASHBOARD_ID,
              VEHICLE_STATUS.DASHBOARD_NAME
            )}
            baseFilterObject={baseFilterObject}
            variableKeys={getVariableKeys}
          />
        </Col>
        <Col span={24}>
          <MotorPanels
            baseUrl={getGrafanaBaseURL(
              VEHICLE_STATUS.DASHBOARD_ID,
              VEHICLE_STATUS.DASHBOARD_NAME
            )}
            baseFilterObject={baseFilterObject}
            variableKeys={getVariableKeys}
          />
        </Col>
        <Col span={24}>
          <BatteryPanels
            baseUrl={getGrafanaBaseURL(
              VEHICLE_STATUS.DASHBOARD_ID,
              VEHICLE_STATUS.DASHBOARD_NAME
            )}
            rear_wheel_diameter={rearTyreDiameter}
            baseBatteryFilterObject={baseBatteryFilterObject}
            baseBatteryStackFilterObject={baseBatteryStackFilterObject}
            baseBatteryCellFilterObject={baseBatteryCellFilterObject}
            variableKeys={getVariableKeys}
          />
        </Col>
      </Row>
    </div>
  );
};

export default VehicleAnalytics;
